export const SET_GLOBAL_MESSAGE_BANNER = 'setGlobalBannerMessage'
export const CLOSE_GLOBAL_BANNER_MESSAGE = 'closeGlobalBannerMessage'
export const SET_FULL_STORY = 'setFullStory'
export const SET_QUICK_APPOINTMENT_STEPPER = 'quickAppointmentStepper'
export const SET_PROMO_DETAILS_EXPERIENCE = 'setPromoDetailsExperience'
export const SET_3_STEPPER_ENABLED = 'set3StepperEnabled'
export const SET_YMME_EXPERIENCE = 'setYmmeExperience'
export const SET_STORE_LOCATOR_PAGE_EXPERIENCE = 'setStoreLocatorPageExperience'
